const fire_names = [
  { name: "Fire Name", value: "Fire Name" },
  { name: "Tubbs", value: "tubbs" },
  { name: "Camp", value: "camp" }
];

export default fire_names;
